import fp from '@auxo.dev/fp'
import produce, { Draft } from 'immer'
import { useCallback, useState } from 'react'

type Predicate<S> = (d: Draft<S>) => void

export interface Func<S> {
  (d: Predicate<S>): void
}

export interface Obj<S> {
  (d: S): void
}

export function useImmer<S>(initialValue: S): [S, Func<S> & Obj<S>] {
  const [value, setValue] = useState(initialValue)

  const updater = useCallback(newValue =>
    fp.isFunction(newValue) ? setValue(produce(newValue)) :
    setValue(newValue)
  , [setValue])

  return [value, updater]
}
